import {
  GET_PRODUCT_GROUP_COMPONENTS,
  GetProductGroupComponentsAction,
  GetProductGroupComponentsPayload,
  PRODUCT_GROUP_COMPONENTS_LOADING,
  ProductGroupComponentsLoadingAction,
  RESET_PRODUCT_GROUP_COMPONENTS,
} from "./ProductGroupComponentsTypes";

export const getProductGroupComponents = (
  payload: GetProductGroupComponentsPayload,
): GetProductGroupComponentsAction => {
  return {
    type: GET_PRODUCT_GROUP_COMPONENTS.REQUEST,
    payload,
  };
};

export const productGroupComponentsLoading = (
  isLoading: boolean,
): ProductGroupComponentsLoadingAction => {
  return {
    type: PRODUCT_GROUP_COMPONENTS_LOADING,
    payload: {
      isLoading,
    },
  };
};

export const resetProductGroupComponents = () => {
  return {
    type: RESET_PRODUCT_GROUP_COMPONENTS,
  };
};
